import { render, staticRenderFns } from "./ListTrucker.vue?vue&type=template&id=2e142ec5&"
import script from "./ListTrucker.vue?vue&type=script&lang=js&"
export * from "./ListTrucker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports